import './listing-highlights.css';
import { useMemo } from 'react';
import { IListing } from '../../models/listing.model';
import { isNullOrUndefinedOrBlank } from '../../util/isNullOrUndefinedOrBlank';
import { listDateToTimeOnMarket } from '../../util/list-date-to-time-on-market';
import { iconBed, iconBath, iconParking, iconPropertySize, iconTimeOnMarket } from '../../util/icons';

interface ListingHighlightProps {
  value: string | number;
  icon: React.ReactNode;
  description: string;
}

const ListingHighlight = (props: ListingHighlightProps) => {
  return (
    <div className="listing-highlight">
      <div className="listing-highlight-icon">{props.icon}</div>
      <div className="listing-highlight-text">
        {props.value}{' '}{props.description}
      </div>
    </div>
  );
};

export interface ListingHighlightsProps {
  listing: IListing;
}

export const ListingHighlights = (props: ListingHighlightsProps) => {

  const timeOnMarket = useMemo(
    () => listDateToTimeOnMarket(props.listing.listDate),
    [props.listing.listDate]
  );

  const timeOnMarketRender = useMemo(() =>
    <ListingHighlight icon={iconTimeOnMarket} value={timeOnMarket.value} description={timeOnMarket.description} />
    , [timeOnMarket.value, timeOnMarket.description]
  );

  const highlights: ListingHighlightProps[] = useMemo(
    () => ([
      { icon: iconBed, value: props.listing.totalBeds, description: 'Bedrooms' },
      { icon: iconBath, value: props.listing.totalBaths, description: 'Bathrooms' },
      { icon: iconParking, value: props.listing.parkingSpaces, description: 'Parking Spaces' },
      { icon: iconPropertySize, value: props.listing.propertySize, description: 'Property Size' }
    ]),
    [props.listing.parkingSpaces, props.listing.propertySize, props.listing.totalBaths, props.listing.totalBeds]
  );

  const highlightsRender = useMemo(() =>
    highlights.map((h, i) => !isNullOrUndefinedOrBlank(h.value) && h.value !== 0 &&
      <ListingHighlight key={i} icon={h.icon} value={h.value} description={h.description} />
    ), [highlights]);

  return (
    <div className="listing-highlights">
      {highlightsRender}
      {timeOnMarketRender}
    </div>
  );
}
